module.exports = __webpack_public_path__ + "img/search-magnifier.99369b53.png";